import React from "react";
import { Box } from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import PlayerHeadshot from "../PlayerHeadshot";
import { chartColors } from "../../theme";

export const SELECTION_HEADSHOT_SIZE = 44;
export const HERO_TWO_PLAYER_HEADSHOT = 112;
export const HERO_MULTI_PLAYER_HEADSHOT = 88;

export const getPlayerAccent = (index) => chartColors[index % chartColors.length];

const HEADSHOT_RING_VARIANTS = {
  selection: { padding: "2px", glow: "35", spread: 12 },
  hero: { padding: "3px", glow: "40", spread: 28 },
};

export const CompareHeadshotRing = ({
  playerId,
  size,
  accent,
  showLoading = false,
  variant = "selection",
  sport = "mlb",
}) => {
  const ring = HEADSHOT_RING_VARIANTS[variant] ?? HEADSHOT_RING_VARIANTS.selection;

  return (
  <Box
    sx={{
      borderRadius: "50%",
      p: ring.padding,
      background: `linear-gradient(135deg, ${accent}, ${accent}55)`,
      boxShadow: `0 0 ${ring.spread}px ${accent}${ring.glow}`,
      flexShrink: 0,
    }}
  >
    <PlayerHeadshot
      playerId={playerId}
      size={size}
      sport={sport}
      showTooltip={false}
      showLoading={showLoading}
      sx={{ border: "none" }}
    />
  </Box>
  );
};

export const CompareSlotPlaceholder = ({ size, accent }) => (
  <Box
    sx={{
      width: size + 4,
      height: size + 4,
      borderRadius: "50%",
      border: `2px dashed ${accent}55`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      bgcolor: "rgba(255, 255, 255, 0.03)",
      color: `${accent}88`,
    }}
  >
    <PersonOutlineIcon sx={{ fontSize: size * 0.45 }} />
  </Box>
);
